import { useState, useMemo } from 'react'

const DEFAULT_PAGE_SIZE = 10

export function usePagination<T>(data: T[], pageSize = DEFAULT_PAGE_SIZE) {
  const [currentPage, setCurrentPage] = useState(1)

  const totalItems = data.length
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize))

  // Reset to page 1 if data shrinks (e.g. after filtering)
  const safePage = Math.min(currentPage, totalPages)
  if (safePage !== currentPage) {
    setCurrentPage(safePage)
  }

  const paginatedData = useMemo(() => {
    const start = (safePage - 1) * pageSize
    return data.slice(start, start + pageSize)
  }, [data, safePage, pageSize])

  return {
    paginatedData,
    currentPage: safePage,
    totalPages,
    totalItems,
    pageSize,
    setCurrentPage,
    hasNextPage: safePage < totalPages,
    hasPreviousPage: safePage > 1,
  }
}
